<template>
  <v-row class="cart-items">
    <v-col
      v-for="(item, index) in items"
      :key="`itemInCart-${index}`"
      class="cart-single-item"
      cols="12">
      <h3 class="mb-3">
        {{ item.name }} ({{ item.campWarehouse }})
      </h3>
      <div class="item-sku-detail pl-4">
        <p>ID: {{ item.code }}</p>
        <div class="sku-variant d-flex">
          <p>
            {{ item.variant1 }}: {{ item.option1 }}
          </p>
          <p>
            {{ item.variant2 }}: {{ item.option2 }}
          </p>
        </div>
        <p class="font-weight-bold">
          {{ item.price | showFullPriceFormat() }} THB
        </p>
      </div>
      <v-btn
        v-if="showBtn"
        class="remove-btn"
        icon
        large
        @click="removeItem(item.id)">
        <v-icon>
          mdi-trash-can-outline
        </v-icon>
      </v-btn>
    </v-col>
    <v-col
      v-if="showBtn"
      class="text-center">
      <v-btn
        color="error"
        @click="clearCart">
        ล้างรายการ
      </v-btn>
    </v-col>
  </v-row>
</template>

<script>
export default {
  props: {
    items: {
      type: Array,
      required: true,
      default: () => []
    },
    showBtn: {
      type: Boolean,
      required: false,
      default: true
    }
  },
  methods: {
    clearCart () {
      this.$emit('onClearCart')
    },
    removeItem (skuId) {
      this.$emit('onRemoveItem', skuId)
    }
  }
}
</script>

<style scoped>
.sku-variant.d-flex> p:first-child {
  min-width: 75px;
  margin-right: 10px;
}
.cart-single-item {
  position: relative;
  border-bottom: 1px solid #c4c4c4;
  margin-bottom: 16px;
}
.row {
  margin-left: 0px !important;
  margin-right: 0px !important;
}
button.remove-btn {
  position: absolute;
  bottom: 30px;
  right: 30px;
  transition: all 0.1s;
}
button.remove-btn:active {
  transform: scale(1.2);
}
</style>
